import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../../_constants/validation-format-constants';
import { GLJournalAttachmentRawDto } from '../../../shared-cirabooks-module/_models/general-ledger/journal-entry/gl-journal-attachment-raw-dto';
import { GLJournalItemRawDto } from './gl-journal-item-raw-dto';

export class GLJournalRawDto {
    glJournalId: number;
    managementCompanyId: number; // Required
    communityId: number;
    cashOrAccrualCode: string; // Required

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    postDate: Date; // Required

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    reversePlanDate: Date;

    description: string;

    @Type(() => GLJournalAttachmentRawDto)
    attachments: GLJournalAttachmentRawDto[];

    @Type(() => GLJournalItemRawDto)
    items: GLJournalItemRawDto[]; // Required

    reversalOfJournalId: number;
}
